<div class="flex flex-col bg-card overflow-hidden height-100p">
  <div
    class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto flex flex-row items-center">
      <ng-container *ngIf="!readonly">
        <button
          *ngIf="isPortfolio && !portfolioSplitCheckbox"
          class="add-contact"
          mat-icon-button
          [matTooltip]="'Split Portfolio'"
          (click)="splitPortfolioCheckbox()"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          <mat-icon [svgIcon]="'call_split'"></mat-icon>
        </button>

        <button
          *ngIf="portfolioSplitCheckbox && !splitRunning"
          class="add-contact"
          mat-button
          color="primary"
          [matTooltip]="'Split Portfolio'"
          [disabled]="!selectedChildProjects.selected?.length"
          (click)="splitPortfolio()"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          Split
        </button>
        <mat-progress-spinner *ngIf="splitRunning" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>

        <button
          *ngIf="portfolioSplitCheckbox && !splitRunning"
          class="add-contact"
          mat-button
          [matTooltip]="'Cancel Split'"
          (click)="splitPortfolioCheckbox()"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          Cancel
        </button>

        <button
          *ngIf="!changeTitleMode"
          class="add-contact"
          mat-icon-button
          matTooltip="Add"
          [matMenuTriggerFor]="addMoreMenu"
          [appAuthorize]="canEditDeal()"
          denyAction="disable"
        >
          <mat-icon
            svgIcon="add"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #addMoreMenu>
          <button mat-menu-item (click)="openPropertyDialog()" type="button" *ngIf="project.child_ids?.length <= 0">
            <mat-icon svgIcon="add"></mat-icon>
            Add Property
          </button>
          <button
            mat-menu-item
            (click)="openCustomDrawer()"
            type="button"
            *ngIf="isPortfolio || project.properties?.length <= 0"
          >
            <mat-icon svgIcon="add"></mat-icon>
            Add Deal to Portfolio
          </button>
        </mat-menu>
      </ng-container>

      <ng-container *ngIf="canEditPanelDef">
        <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCardMenu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button
            mat-menu-item
            (click)="convertToPortolio()"
            type="button"
            *ngIf="!isPortfolio && project.properties?.length > 0"
            [matTooltip]="'Convert to Portfolio'"
            [appAuthorize]="canEditDeal()"
            denyAction="disable"
          >
            <mat-icon [svgIcon]="'account_tree'"></mat-icon>
            Convert to Portfolio
          </button>
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="changeTitleMode"
          [matTooltip]="'Cancel'"
          (click)="toggleEditMode(false)"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
  <section class="w-full h-full">
    <ng-container *ngIf="properties.length || children.length">
      <section class="w-full h-2/3">
        <parcel-map
          (onSelectParcelEvent)="onSelectParcel($event)"
          (onSelectLatLngEevnt)="onSelectLatLng($event)"
          [properties]="(NewPermission.PROPERTIES_VIEW | hasPermission) && !isAddressHidden ? properties : []"
          [showPin]="!isAddressHidden"
          [allowClickEvent]="!isAddressHidden"
          [center]="{ latitude: lat, longitude: lng }"
        ></parcel-map>
      </section>
    </ng-container>
    <div class="w-full h-1/3 overflow-x-auto">
      <div class="loader" *ngIf="loadingParcel">
        <mat-progress-bar class="table-loading-bar" [mode]="'indeterminate'"></mat-progress-bar>
      </div>

      @if (NewPermission.PROPERTIES_VIEW | hasPermission) {
        <ng-container *ngIf="!isPortfolio">
          <ng-container *ngIf="properties.length; else NoAddresses">
            @if (newTable) {
              <ts-table [columnDefs]="columnDefs" [rowData]="properties" [actions]="actions"> </ts-table>
            } @else {
              <table
                class="w-full bg-transparent"
                mat-table
                matSort
                [dataSource]="properties"
                [trackBy]="trackByFn"
                #addressTable
              >
                <!-- Address -->
                <ng-container matColumnDef="address">
                  <th
                    class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef
                  >
                    <span class="whitespace-no-wrap">Address</span>
                  </th>
                  <td mat-cell *matCellDef="let property">
                    <div class="flex flex-row items-center">
                      <span class="flex flex-col w-fit">
                        <div class="pr-2 whitespace-no-wrap address-string">
                          <span
                            class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
                            *ngIf="property.livability_score && property.livability_score > 0"
                            [ngClass]="[
                              property.livability_score >= 80 ? 'green-100' : '',
                              property.livability_score < 80 && property.livability_score >= 40 ? 'orange-100' : '',
                              property.livability_score < 40 ? 'red-300' : '',
                            ]"
                          >
                            <span class="leading-relaxed whitespace-no-wrap">{{ property.livability_score }}</span>
                          </span>
                          <span class="ml-2">
                            <a
                              [routerLink]="['/properties/' + property.id]"
                              class="underline text-ellipsis"
                              data-cy="map-panel-project-property"
                            >
                              {{ property?.name || property.address?.address_string }}
                            </a>
                          </span>
                        </div>
                        <div class="text-sm text-hint">
                          {{ property.property_type?.name }} •
                          <span *ngIf="property.apn">{{ property.apn }} • </span>
                          <span *ngIf="property.year_built">Built in {{ property.year_built }} • </span>
                          <span *ngIf="property.unit_size">{{ property.unit_size }} Units • </span>
                          <span *ngIf="property.rentable_sq_ft && property.rentable_sq_ft > 0"
                            >{{ property.rentable_sq_ft | formatNumber: 0 }} SF •
                          </span>
                          <span *ngIf="property.parcel_size && property.parcel_size > 0"
                            >{{ property.parcel_size | formatNumber: 2 }} Acres •
                          </span>
                          <span *ngIf="property.last_sale_price && property.last_sale_price > 0">
                            Last Sale: {{ property.last_sale_price | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                            <span *ngIf="property.last_sale_date"> on {{ property.last_sale_date | formatDate }} </span>
                          </span>
                        </div>
                      </span>
                    </div>
                  </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                  <th
                    class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef
                  ></th>
                  <td mat-cell *matCellDef="let property">
                    <div *ngIf="!portfolioSplitCheckbox" class="flex flex-row justify-end">
                      <!-- Center Property -->
                      <button
                        mat-icon-button
                        [matTooltip]="'Center property on map'"
                        (click)="centerProperty(property)"
                      >
                        <mat-icon [svgIcon]="'my_location'"></mat-icon>
                      </button>
                      <!-- Visualization Menu -->
                      <button
                        class="more-menu"
                        mat-icon-button
                        [matMenuTriggerFor]="visualizationMenu"
                        [matTooltip]="'View on...'"
                      >
                        <mat-icon [svgIcon]="'language'"></mat-icon>
                      </button>
                      <mat-menu #visualizationMenu="matMenu">
                        <section class="flex flex-col">
                          <!-- Google Earth -->
                          <a
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            href="https://earth.google.com/web/@{{ property.address?.latitude }},{{
                              property.address?.longitude
                            }},{{ googleEarthConfig.cameraAltitude }}d,{{ googleEarthConfig.zoom }}z"
                            target="_blank"
                            [matTooltip]="'View on Google Earth'"
                            [matTooltipPosition]="'right'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'public'"></mat-icon>
                            Google Earth
                          </a>
                          <!-- Google Maps -->
                          <a
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            href="https://www.google.com/maps?q=loc:{{ property.address?.latitude }}+{{
                              property.address?.longitude
                            }}&ll={{ property.address?.latitude }},{{ property.address?.longitude }}&t=h"
                            target="_blank"
                            [matTooltip]="'View on Google Maps'"
                            [matTooltipPosition]="'right'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'location_on'"></mat-icon>
                            Google Maps
                          </a>
                          <!-- Parcel Map -->
                          <a
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            (click)="goToResearch(property)"
                            [matTooltip]="'View on Parcel Map'"
                            [matTooltipPosition]="'left'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'map'"></mat-icon>
                            Parcel Map
                          </a>
                        </section>
                      </mat-menu>

                      <!-- Demographics -->
                      <a
                        *ngIf="!readonly"
                        class="mat-focus-indicator mat-icon-button mat-button-base"
                        (click)="openDemographicDialog(property)"
                        [matTooltip]="'View Demographics'"
                      >
                        <mat-icon class="icon-size-20 mr-1" [svgIcon]="'supervisor_account'"></mat-icon>
                      </a>

                      <!-- More Menu -->
                      <button
                        class="more-menu"
                        mat-icon-button
                        [appAuthorize]="canEditDeal()"
                        [matMenuTriggerFor]="moreMenu"
                        [matTooltip]="'More'"
                        *ngIf="!readonly"
                      >
                        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                      </button>
                      <mat-menu #moreMenu="matMenu">
                        <button *ngIf="isPortfolio" mat-menu-item (click)="moveToSingleDeal(property)">
                          <mat-icon [svgIcon]="'eject'"></mat-icon>
                          Move to Single Deal
                        </button>
                        <button mat-menu-item (click)="openPropertyDialog(property)">
                          <mat-icon [svgIcon]="'edit'"></mat-icon>
                          Edit
                        </button>
                        <button mat-menu-item (click)="deleteProperty(property)">
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                          <span>Remove</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr
                  data-cy="property-panel-row"
                  class="order-row h-16"
                  mat-row
                  *matRowDef="let row; columns: displayColumns"
                ></tr>
              </table>
            }
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isPortfolio">
          <ng-container *ngIf="children.length; else NoAddresses">
            @if (newTable) {
              <ts-table
                [columnDefs]="columnDefs"
                [hasCheckboxColumn]="portfolioSplitCheckbox"
                [headerCheckboxSelection]="false"
                [hasActionsColumn]="true"
                [rowData]="children"
                [actions]="actions"
                [checkboxColumnChanged]="checkboxColumnChanged"
                (selectionChanged)="onSelectionChanged($event)"
              >
              </ts-table>
            } @else {
              <table
                class="w-full bg-transparent"
                mat-table
                matSort
                [dataSource]="children"
                [trackBy]="trackByFn"
                #addressTable
              >
                <!-- Address -->
                <ng-container matColumnDef="address">
                  <th
                    class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef
                  >
                    <span class="whitespace-no-wrap">Portfolio</span>
                  </th>
                  <td mat-cell *matCellDef="let childProject">
                    <div class="flex flex-row items-center">
                      <mat-checkbox
                        *ngIf="portfolioSplitCheckbox"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selectedChildProjects.toggle(childProject) : null"
                        [checked]="selectedChildProjects.isSelected(childProject)"
                        tabindex="-1"
                        class="split-portfolio"
                      ></mat-checkbox>
                      <span class="flex flex-col w-fit">
                        <div class="pr-2 whitespace-no-wrap address-string">
                          <span>
                            <a
                              [routerLink]="[
                                '/projects/' + childProject.pipeline_id + '/' + childProject.id + '/details/overview',
                              ]"
                              class="underline text-ellipsis"
                              data-cy="map-panel-project-portfolio-child"
                            >
                              {{ childProject?.title || childProject.address?.address_string }}
                            </a>
                          </span>
                        </div>
                        <div class="text-sm text-hint">
                          {{ childProject.property_type?.name }}
                          <span *ngIf="childProject.properties?.length > 0">
                            • {{ childProject.address?.address_string }} •
                          </span>
                        </div>
                      </span>
                    </div>
                  </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                  <th
                    class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef
                  ></th>
                  <td mat-cell *matCellDef="let childProject">
                    <div *ngIf="!portfolioSplitCheckbox" class="flex flex-row justify-end">
                      <!-- Center Property -->
                      <button
                        mat-icon-button
                        [matTooltip]="'Center property on map'"
                        (click)="centerProperty(childProject)"
                      >
                        <mat-icon [svgIcon]="'my_location'"></mat-icon>
                      </button>
                      <!-- Visualization Menu -->
                      <button
                        class="more-menu"
                        mat-icon-button
                        [matMenuTriggerFor]="visualizationChildrenMenu"
                        [matTooltip]="'View on...'"
                      >
                        <mat-icon [svgIcon]="'language'"></mat-icon>
                      </button>
                      <mat-menu #visualizationChildrenMenu="matMenu">
                        <section class="flex flex-col">
                          <!-- Google Earth -->
                          <a
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            href="https://earth.google.com/web/@{{ childProject.address?.latitude }},{{
                              childProject.address?.longitude
                            }},{{ googleEarthConfig.cameraAltitude }}d,{{ googleEarthConfig.zoom }}z"
                            target="_blank"
                            [matTooltip]="'View on Google Earth'"
                            [matTooltipPosition]="'right'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'public'"></mat-icon>
                            Google Earth
                          </a>
                          <!-- Google Maps -->
                          <a
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            href="https://www.google.com/maps?q=loc:{{ childProject.address?.latitude }}+{{
                              childProject.address?.longitude
                            }}&ll={{ childProject.address?.latitude }},{{ childProject.address?.longitude }}&t=h"
                            target="_blank"
                            [matTooltip]="'View on Google Maps'"
                            [matTooltipPosition]="'right'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'location_on'"></mat-icon>
                            Google Maps
                          </a>
                          <!-- Parcel Map -->
                          <a
                            *ngIf="childProject.properties?.length > 0"
                            class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                            (click)="goToResearch(childProject.properties[0])"
                            [matTooltip]="'View on Parcel Map'"
                            [matTooltipPosition]="'left'"
                          >
                            <mat-icon class="icon-size-20 mr-1" [svgIcon]="'map'"></mat-icon>
                            Parcel Map
                          </a>
                        </section>
                      </mat-menu>

                      <!-- Demographics -->
                      <a
                        *ngIf="!readonly && childProject.properties?.length > 0"
                        class="mat-focus-indicator mat-icon-button mat-button-base"
                        (click)="openDemographicDialog(childProject.properties[0])"
                        [matTooltip]="'View Demographics'"
                      >
                        <mat-icon class="icon-size-20 mr-1" [svgIcon]="'supervisor_account'"></mat-icon>
                      </a>

                      <!-- More Menu -->
                      <button
                        class="more-menu"
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        [matTooltip]="'More'"
                        *ngIf="!readonly"
                      >
                        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                      </button>
                      <mat-menu #moreMenu="matMenu">
                        <button mat-menu-item (click)="moveToSingleDeal(childProject)">
                          <mat-icon [svgIcon]="'eject'"></mat-icon>
                          Move to Single Deal
                        </button>
                        <button mat-menu-item (click)="deleteProperty(childProject)">
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                          <span>Remove</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr
                  data-cy="property-panel-row"
                  class="order-row h-16"
                  mat-row
                  *matRowDef="let row; columns: displayColumns"
                ></tr>
              </table>
            }
          </ng-container>
        </ng-container>
      }
    </div>
  </section>
</div>

<ng-template #NoAddresses>
  <div class="flex flex-col items-center justify-center h-full py-8">
    <mat-icon class="icon-size-40" [svgIcon]="'location_off'"></mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No Properties</p>
    <p class="text-sm text-secondary mt-2">
      Add properties to this panel by clicking in the
      <mat-icon class="icon-size-14" [svgIcon]="'add'"></mat-icon>
      button above.
    </p>
  </div>
</ng-template>
